import React from 'react';
import { Flex } from '@osmosis/react-ui/components/Box';
import { useQuizContext } from '../../../../context/QuizContext';
import { QuizContainer } from '../../QuizContainer';
import { EnhancedHotSpotData } from '../../../../types/quiz';
import EnhancedHotSpotArea from './EnhancedHotSpotArea';

/**
 * Https://elsevier.atlassian.net/browse/OSMS-685.
 */

/**
 * EnhancedHotSpot.
 */
const EnhancedHotSpot = () => {
  const { currentItem } = useQuizContext();

  return (
    <Flex flexDirection="column">
      <QuizContainer>
        <div
          data-testid="directions-wrapper"
          className="text-justify"
          dangerouslySetInnerHTML={{
            __html: (currentItem?.data as EnhancedHotSpotData).directions,
          }}
          style={{ marginBottom: '1rem' }}
        />
        <EnhancedHotSpotArea />
      </QuizContainer>
    </Flex>
  );
};

export default EnhancedHotSpot;
